module.exports = __webpack_public_path__ + "img/_checkmark.a9d27ae0.svg";